import React from "react";
import Preloader from "../helper/Preloader";

import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import VendorLogin from "../components/VendorLogin";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";


const VendorLoginPage = () => {

  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color="#FA6400" />
      <Preloader />
      <HeaderTwo category={true} />
      <Breadcrumb title={"Vendor Login"} />
      <VendorLogin />
      <ShippingOne />
      <FooterTwo />
      <BottomFooter />
    </>
  );
};

export default VendorLoginPage;
